// extracted by mini-css-extract-plugin
export var cardContainer = "_p4-0";
export var cardHeader = "_p4-2";
export var collapsedState = "_p4-3";
export var dragHandle = "_p4-5";
export var dragHandleIcon = "_p4-6";
export var dragging = "_p4-1";
export var titleArea = "_p4-4";